module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"sexadecimal":"Sexadecimal","decimal":"Decimal","copy_to_clipboard":"Copy to Clipboard","ruler":"Ruler"},"ja":{"sexadecimal":"60進","decimal":"10進","copy_to_clipboard":"コピー","ruler":"ルーラー"}}')
  delete Component.options._Ctor
}
